import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Divider,
  Typography,
  TextField,
  Grid,
  Button
} from '@material-ui/core';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { useClientContext } from '../../../context/client_context';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'groupName', label: 'Group Name', alignRight: false },
  { id: 'ageBand', label: 'Age Band', alignRight: true },
  { id: 'maxAge', label: 'Max Age', alignRight: true },
  { id: 'scheme', label: 'Scheme', alignRight: false },
  { id: 'count', label: 'Total', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function MembershipAgeGroup() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });
  const filename = `MembershipByAgeGroup_${moment().format('[monthly-]MMDDYYYYHHmm[.csv]')}`;
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    getMembershipByAgeGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const getMembershipByAgeGroup = () => {
    fetch(`${baseUrl}/api/client/GetRptAgeProfile?asDate=${moment(begDate).format('YYYY-MM-DD')}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned Member Age Group list', result);
          setDataList(result.result);
        },
        (error) => {
          notifyPopup(`Error in Disbursing Payment!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <Typography component="span" variant="h4" gutterBottom>
            Membership by Age Group
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              inputFormat="dd/MM/yyyy"
              value={begDate}
              onChange={(e) => {
                setBegDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getMembershipByAgeGroup()}
          >
            Refresh
          </Button>
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <CSVLink data={dataList} filename={filename}>
            <Button type="button" variant="outlined" startIcon={<CloudDownloadIcon />}>
              Export
            </Button>
          </CSVLink>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const { groupName, ageBand, maxAge, scheme, kount } = row;
                    const isItemSelected = selected.indexOf(groupName) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={groupName}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{groupName}</TableCell>
                        <TableCell align="right">{ageBand}</TableCell>
                        <TableCell align="right">{maxAge}</TableCell>
                        <TableCell align="left">{scheme}</TableCell>
                        <TableCell align="right">{kount}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isListEmpty && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
